export const BONUS_CARDS_CONSTS = {
    GET_BONUS_CARD: "GET_BONUS_CARD",
    CHECK_BONUS_CARD: "CHECK_BONUS_CARD",
    GET_HISTORY: "GET_HISTORY",
};
